function injectStyle (ssrContext) {
  require("!!../../node_modules/._extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-34f13dce\",\"scoped\":false,\"hasInlineConfig\":true}!less-loader?{\"sourceMap\":true}!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/selector?type=styles&index=0!./ResearchPart3.vue")
}
var normalizeComponent = require("!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./ResearchPart3.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./ResearchPart3.vue"
/* template */
import __vue_template__ from "!!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-34f13dce\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/._vue-loader@13.7.3@vue-loader/lib/selector?type=template&index=0!./ResearchPart3.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ResearchPart3.vue
// module id = null
// module chunks = 